import { Grid } from '@mui/material'
import React from 'react'
import SurveyForm from '../SurveyForm/SurveyForm';
import "./ClientHeatMap.scss";
import PropTypes from 'prop-types';
import { isAdmin, isUser } from '../../utils/Permissions';
import AdminSurveyForm from '../AdminSurveyForm/AdminSurveyForm';
import messages from '../../assets/locale/messages';
import { useSelector } from "react-redux";



const ClientSatisfactionScore = ({ adminclientClassifiction }) => {
    const lang = useSelector((state) => state.locale.lang);
    const { clientSatisfaction } = messages[lang];

    return (
        <div className="events-list-container">
            <div className="page-title-margin">
                <div className="file-wrapper">
                    <div className="file-component-header mb-4">
                        <Grid container spacing={2} alignItems={'center'}>
                            <Grid item xs={12} md={6}>
                                <div className="flex flex-column">
                                    <h2 className="title fsize-24 text-darkgrey">{clientSatisfaction.title}</h2>
                                    <p className="fsize-14 text-grey">{clientSatisfaction.desc}</p>
                                </div>
                            </Grid>

                        </Grid>
                    </div>
                    <div className="file-component-body">
                        
                        {isAdmin() && <AdminSurveyForm adminclientClassifiction={adminclientClassifiction} />}
                        {isUser() && <SurveyForm adminclientClassifiction={false} />}


                    </div>
                </div>
            </div>
        </div>
    )
}
ClientSatisfactionScore.propTypes = {
    adminclientClassifiction: PropTypes.bool.isRequired, // Ensure it's a required boolean
};
export default ClientSatisfactionScore
